import { environment } from '../../../environments/environment';
import { OrdenItem } from '../../domain/orden.domain';
import { TarifaDetalle } from '../../domain/tarifa-detalle.domain';
import { PricingTrace } from './pricing-trace.model';
import { resolveSubtotalFinal } from './pricing-override';

export class PricingDebugLogger {
  private readonly envEnabled = !!environment.pricingDebug;

  isEnabled(): boolean {
    if (this.envEnabled) {
      return true;
    }
    try {
      return localStorage.getItem('pricingDebug') === '1';
    } catch {
      return false;
    }
  }

  logItem(item: Partial<OrdenItem>, trace: PricingTrace, matched?: TarifaDetalle | null): void {
    if (!this.isEnabled()) {
      return;
    }
    const tipoProducto = typeof item.tipoProducto === 'object' ? item.tipoProducto : null;
    const title = `Pricing item ${item.id ?? item.ordenIndex ?? '-'} ${tipoProducto?.codigo ?? ''}`.trim();
    console.groupCollapsed(title);
    console.log('Inputs', trace.match.inputs);
    if (trace.match.baseCandidatesIds) {
      console.log('Base candidates', trace.match.baseCandidatesIds);
    }
    if (trace.match.acceptedCandidatesIds) {
      console.log('Accepted candidates', trace.match.acceptedCandidatesIds);
    }
    console.log('Match candidates', trace.match.candidates);
    console.log('Match rejections', trace.match.rejections);
    if (trace.match.rejectionsByDetalleId) {
      console.log('Rejections by detalle', trace.match.rejectionsByDetalleId);
    }
    if (matched) {
      console.log('Matched detalle', {
        id: matched.id,
        prioridad: matched.prioridad,
        precioUnitario: matched.precioUnitario,
        unidadTarifacion: matched.unidadTarifacion
      });
    }
    if (trace.calculation) {
      console.log('Calculation', {
        formula: trace.calculation.formula,
        billingQty: trace.calculation.billingQty,
        factor: trace.calculation.factor,
        subtotalPreview: trace.calculation.subtotalPreview,
        inputs: trace.calculation.inputs
      });
    }
    console.log('Override', {
      subtotalManual: item.subtotalManual ?? null,
      subtotalFinal: resolveSubtotalFinal({
        subtotalManual: item.subtotalManual ?? null,
        subtotalPreview: trace.calculation?.subtotalPreview ?? null,
        subtotalSnapshot: (item as any).subtotalSnapshot ?? null,
        subtotal: (item as any).subtotal ?? null
      })
    });
    console.groupEnd();
  }
}
